export default {
  strict: true,
  namespaced: true,
  state: {
    logs: {
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      since: null,
      until: null,
      reachMax: false,

      profileHistory: {
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 20,
        since: null,
        until: null,
        reachMax: false,
      },
      activityHistory: {
        list: [],
        loading: false,
        pageNum: 1,
        pageSize: 20,
        since: null,
        until: null,
        reachMax: false,
      }
    }
  },
  mutations: {
    addLogs (state, value) { state.logs.list.push(value) },
    setLogsField (state, data) {
      state.logs[data.field] = data.value
      for (let field in data.fields) {
        state.logs[field] = data.fields[field]
      }
    },

    addProfileHistory (state, value) { state.logs.profileHistory.list.push(value) },
    setProfileHistoryField (state, data) {
      state.logs.profileHistory[data.field] = data.value
      for (let field in data.fields) {
        state.logs.profileHistory[field] = data.fields[field]
      }
    },
    addActivityHistory (state, value) { state.logs.activityHistory.list.push(value) },
    setActivityHistoryField (state, data) {
      state.logs.activityHistory[data.field] = data.value
      for (let field in data.fields) {
        state.logs.activityHistory[field] = data.fields[field]
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/provider/logs.js